import React, { useEffect, useRef } from "react";

// Cloudflare Turnstile (betik public/index.html'de yükleniyor). Localhost'ta Cloudflare'in her zaman geçen test site
// anahtarı kullanılır; yerel backend (NODE_ENV=development) onun sahte token'ını kabul eder.
const PROD_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAADeL02opQoKacfFr";
const TEST_SITE_KEY = "1x00000000000000000000AA";
const isLocalHost = () => ["localhost", "127.0.0.1"].includes(window.location.hostname);

interface TurnstileProps {
  onToken: (token: string | null) => void;
  // Değişince bileşen sıfırlanır (başarısız istekten sonra yeni token gerekir)
  resetKey?: number;
}

export default function Turnstile({ onToken, resetKey = 0 }: TurnstileProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetIdRef = useRef<string | null>(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | null = null;
    const w = window as any;

    // Betik async yükleniyor; hazır olana kadar yokla (onload geri çağrısına güvenme).
    const render = () => {
      if (cancelled || !containerRef.current) return;
      if (!w.turnstile?.render) {
        timer = setTimeout(render, 200);
        return;
      }
      widgetIdRef.current = w.turnstile.render(containerRef.current, {
        sitekey: isLocalHost() ? TEST_SITE_KEY : PROD_SITE_KEY,
        callback: (token: string) => onTokenRef.current(token),
        "expired-callback": () => onTokenRef.current(null),
        "error-callback": () => onTokenRef.current(null),
        theme: "light",
        language: "tr",
        size: "flexible",
      });
    };
    render();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
      if (widgetIdRef.current && w.turnstile?.remove) {
        try { w.turnstile.remove(widgetIdRef.current); } catch (_) { }
      }
      widgetIdRef.current = null;
      onTokenRef.current(null);
    };
  }, [resetKey]);

  return <div ref={containerRef} className="min-h-[65px]" />;
}
